/***** modal *****/
    var $body = $('body');
    var scrollTop;

    function bodyFixedOn() {
      scrollTop = $(window).scrollTop();  
      $body.css({position: 'fixed', top: -scrollTop, width: '100%'});
      $('section.modal_switcher').removeClass('hide').addClass('show');
    }

    function bodyFixedOff() {
      $body.css({position: '', top: '', width: 'auto'});
      $(window).scrollTop(scrollTop);
      $('section.modal_switcher').removeClass('show').addClass('hide');
    }

    $('.modal_trigger').on('click', function() {
      bodyFixedOn();
    });

    $('.modal_close').on('click', function() {
      bodyFixedOff();
    });

    $('.overlay').on('click', function() {
      bodyFixedOff();
    });
 /***** /modal *****/

/***** switcher *****/
    $(function () {
      var paraGety = function paraGety(para) {
        var pageURL = window.location.search.substring(1),
        urlValue = pageURL.split('&'), paraName;
        for(var i = 0; i < urlValue.length; i++) {
          paraName = urlValue[i].split('=');
          if (paraName[0] === para) {
            return paraName[1] === undefined ? true : decodeURIComponent(paraName[1]);
          }
        }
      };
      var result = paraGety('currency');
      var cry = (result == undefined) ? 'jpy' : (result == 'jpy') ? 'jpy' : (result == 'usd') ? 'usd' : (result == 'cad') ? 'cad' : (result == 'aud') ? 'aud' : (result == 'gbp') ? 'gbp' : (result == 'eur') ? 'eur' : (result == 'cny') ? 'cny' : (result == 'krw') ? 'krw' : (result == 'hkd') ? 'hkd' : (result == 'twd') ? 'twd' : '';
      $('section.modal_switcher > nav > dl:nth-of-type(2) > dd#'+ cry +' > a').css({background: '#000', color: '#fff'});
    });
/***** /switcher *****/

/***** accordion *****/
// $(function() {
//   $('button#AddToCart').on('click', function() {
//     $('p.cart-all').addClass('show');
//     $('p.cart-all').css('display','initial');
//   });
// });
/***** /accordion *****/


<!-- modal -->
window.onload = function() {
  var modal = document.getElementById('js-modal');
  if(!modal) return;
  modal.classList.add('is-show');

  var blackBg = document.getElementById('js-black-bg');
  var closeBtn = document.getElementById('js-close-btn');
  closePopUp(blackBg);
  closePopUp(closeBtn);

  function closePopUp(elem) {
    if(!elem) return;
    elem.addEventListener('click', function() {
      modal.classList.remove('is-show');
    })
  }
}

    $(function(){
        $(".modal").show();
        $.cookie('btnFlg') == 'on'?$(".modal").hide():$(".modal").show();
        $(".modal-inner").click(function(){
            $(".modal").fadeOut();
        });
    });

$(document).ready(function() {
 $(".show_timer").each(function(index, target) {
   var startDate = $(this).attr("data-startdate");
   var endDate = $(this).attr("data-enddate");
   var nowDate = new Date();
   if (startDate) {
     startDate = new Date(startDate);
   } else {
     startDate = nowDate;
   }
   if (endDate) {
     endDate = new Date(endDate);
   }
   if (startDate <= nowDate && (!endDate || nowDate <= endDate)) {
     $(this).show();
   } else {
     $(this).hide();
   }
 });
});

/***** header caution *****/
$(function(){
    $(".readmore").on("click", function() {
        $(this).toggleClass("on-click");
        $(".hide-text").slideToggle(500);
    });
}); 
/***** /header caution *****/